import { loadMessages, locale } from 'devextreme/localization';
import Calendar from 'devextreme/ui/calendar';
import 'devextreme/localization/globalize/number';
import 'devextreme/localization/globalize/currency';
import 'devextreme/localization/globalize/date';
import Globalize from 'globalize';
import supplemental from 'devextreme-cldr-data/supplemental.json';
import english from 'devextreme-cldr-data/en.json';
import vietnamese from 'devextreme-cldr-data/vi.json';
import german from 'devextreme-cldr-data/de.json';

export type WidgetMessages = Record<string, Record<string, string>>;

// Keep each locale's calendar data, but share the English numeric conventions.
// All adapters use the public DevExtreme Globalize integration.
Globalize.load(supplemental);
const calendarData = { en: english.main.en, vi: vietnamese.main.vi, de: german.main.de };
for (const language of ['en', 'vi', 'de'] as const) {
    Globalize.load({ main: { [language]: {
        ...calendarData[language],
        numbers: english.main.en.numbers,
    } } });
}

/** Shared numeric conventions without forcing the calendar into an English locale. */
export function setWidgetNumberLocale(language: string, messages: WidgetMessages): void {
    const lang = language.toLowerCase().split('-')[0];
    const selected = ['en', 'vi', 'de'].includes(lang) ? lang : 'en';
    loadMessages({ [selected]: { ...messages.en, ...messages[selected] } });
    locale(selected);
    // Existing DateBox popups retain their Calendar instance between openings.
    // Repaint via the public widget API so a language switch also updates them.
    if (typeof document !== 'undefined') {
        document.querySelectorAll<HTMLElement>('.dx-calendar').forEach(element => {
            const calendar = Calendar.getInstance(element);
            if (calendar instanceof Calendar) calendar.repaint();
        });
    }
}
